"use strict";

require("core-js/modules/es.reflect.construct.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.weak-map.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

require("core-js/modules/es.function.bind.js");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _formElements = require("@evidation/form-elements");

var _moment = _interopRequireDefault(require("moment"));

var _utils = require("./utils");

var _excluded = ["format"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var BASE_FORMAT = "HH:mm";

var Time = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(Time, _PureComponent);

  var _super = _createSuper(Time);

  function Time(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Time);
    _this = _super.call(this, props);
    var value = props.input.value ? props.input.value : '13:00';
    _this.state = {
      value: value
    };
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Time, [{
    key: "onChange",
    value: function onChange(v) {
      var _util_commonInputPara = (0, _utils.util_commonInputParamters)(this.props),
          onChange = _util_commonInputPara.onChange,
          onBlur = _util_commonInputPara.onBlur,
          _util_commonInputPara2 = _util_commonInputPara.format,
          format = _util_commonInputPara2 === void 0 ? BASE_FORMAT : _util_commonInputPara2;

      var value = v.format(format);
      onBlur();
      this.setState({
        value: value
      }, function () {
        return onChange(value);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var value = this.state.value;

      var _util_commonInputPara3 = (0, _utils.util_commonInputParamters)(this.props),
          _util_commonInputPara4 = _util_commonInputPara3.format,
          format = _util_commonInputPara4 === void 0 ? BASE_FORMAT : _util_commonInputPara4,
          fieldProps = (0, _objectWithoutProperties2["default"])(_util_commonInputPara3, _excluded);

      return /*#__PURE__*/_react["default"].createElement(_formElements.TimeInput, (0, _extends2["default"])({}, fieldProps, {
        format: format,
        showSecond: false,
        defaultOpenValue: (0, _moment["default"])('12:00', format),
        defaultValue: (0, _moment["default"])('12:00', format),
        value: (0, _moment["default"])(value, format),
        onChange: this.onChange
      }));
    }
  }]);
  return Time;
}(_react.PureComponent);

Time.defaultProps = {
  showSecond: false,
  use12Hours: false
};
var _default = Time;
exports["default"] = _default;